var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"k-audio-wrap"},[_c('audio',{staticClass:"k-audio js-k-audio",attrs:{"src":"https://staticcdn-yy-prd.pydp888.com/data/mp3/none.mp3","crossorigin":"anonymous"}})])
}]

export { render, staticRenderFns }